import { useEffect, useState } from "react";
import "./comingsoon.css";
import Gifanimationvideo from "./GIFanimation.mp4";

function ComingSoon() {
  const fullText = "Coming Soon...";
  const [displayText, setDisplayText] = useState("");

  useEffect(() => {
    let index = 0;

    const interval = setInterval(() => {
      setDisplayText(fullText.slice(0, index + 1));

      index++;

      if (index >= fullText.length) {
        clearInterval(interval);
      }
    }, 120);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="coming-soon-page">
      <header className="coming-soon-header">
        <div className="coming-soon-logo">
          {JSON.parse(localStorage.getItem("site_data"))?.title}
        </div>
      </header>

      <div className="coming-soon-content">
        <h1 className="coming-soon-title">{displayText}</h1>

        <video
          className="coming-soon-video"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src={Gifanimationvideo} type="video/mp4" />
        </video>
      </div>
    </div>
  );
}

export default ComingSoon;